/**
 * 线上环境
 */
export const ONLINEHOST = 'https://www.ahlzz.com/api/'  //正式环境
// export const ONLINEHOST = 'http://112.30.60.51:8196/api/' //测试环境2
// export const ONLINEHOST = 'http://192.168.20.55:8196/api/'  //测试环境2.0+
// export const ONLINETREEHOST = 'http://106.15.178.238:8091/' //古树正式环境
// export const ONLINETREEHOST = 'http://192.168.20.55:8901/api/'  //测试环境1
export const ONLINETREEHOST = 'https://tree.linzhangyun.com/api/'  //古树正式环境
export const ONLINEUPLOADHOST = "https://dtools.ahdhst.com/dfs/"; //上传请求

/**
 * 测试环境
 */
// export const QAHOST = 'http://192.168.20.55:8194/api/'  //测试环境1
export const QAHOST = 'https://www.ahlzz.com/api/'  //测试环境2.0+
// export const QAHOST = 'http://112.30.60.51:8196/api/'  //测试环境2.5+
// export const QAHOST = 'https://www.ahlzz.com/api/' //测试环境2
// export const QAHOST = 'http://192.168.21.221:8196/api/' //陈国贵
// export const QAHOST = 'http://192.168.30.104:8196/api/' //王愿
// export const QAHOST = 'http://192.168.30.59:8195/api/' //肖东 
//export const QAHOST = 'http://192.168.1.159:8091/' //刘伟
//export const QAHOST = 'http://192.168.1.135:8091/' //张涛山 

//古树名木
export const QATREEHOST = 'https://tree.linzhangyun.com/api/'  //测试环境1
// export const QATREEHOST = 'https://tree.linzhangyun.com/api/'  //测试环境1
 
// export const QATREEHOST = 'http://112.30.60.51:8901/api/'  //测试环境1
// export const QATREEHOST = 'http://106.15.178.238:8091/' //古树正式环境
// export const QATREEHOST = 'http://112.30.60.51:8901/api/' //陈国贵
// export const QATREEHOST = 'http://192.168.1.82:8099/' //谢明
// export const QATREEHOST = 'http://192.168.1.89:8099/' //测试环境2
export const DEVUPLOADVHOST = 'https://dtools.ahdhst.com/dfs/' //测试环境上传接口
/**
 * 当前的host  ONLINEHOST | QAHOST | MOCKHOST
 */
export const MAINHOST =
  process.env.NODE_ENV === 'development' ? QAHOST : ONLINEHOST
//古树请求主机
export const TreeHOST =
  process.env.NODE_ENV === 'development' ? QATREEHOST : ONLINETREEHOST


//上传请求主机
export const UPLOADHOST =
  process.env.NODE_ENV === 'development' ?
  DEVUPLOADVHOST : ONLINEUPLOADHOST

//websokit之恋数据
export const Websokit =
  process.env.NODE_ENV === 'development' ?
  'http://192.168.20.55:8902' : 'https://ws-tree.linzhangyun.com/'
/**
 * @description token在Cookie中存储的天数，默认1天
 */
export const cookieExpires = 1